<template>
    <v-container  v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading" >
            <v-menu v-if="this.isMobile" d-inline  :close-on-content-click="true">
                <v-btn outline small slot="activator">
                    Sort <v-icon>sort</v-icon>
                </v-btn>
                <v-list>
                    <v-subheader>
                        Sort by:
                    </v-subheader>
                    <v-list-tile v-for="(item, index) in headers.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                        <v-list-tile-title>
                            {{ item.text }}
                            <v-icon v-if="pagination.sortBy === item.value">{{pagination.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>

            <v-layout row wrap>
                <v-flex xs12 md4 lg2>
                    <count-up
                    :endVal="houseMax"
                    text="House highest number of sitting days"
                    />
                </v-flex>
                <v-flex xs12 md4 lg2>
                    <count-up
                    :endVal="houseMin"
                    text="House lowest number of sitting days"
                    />
                </v-flex>
                <v-flex xs12 md4 lg2>
                    <count-up
                    :endVal="houseAvg"
                    text="House average number of sitting days"
                    />
                </v-flex>
                <v-flex xs12 md4 lg2>
                    <count-up
                    :endVal="senateMax"
                    text="Senate highest number of sitting days"
                    />
                </v-flex>
                <v-flex xs12 md4 lg2>
                    <count-up
                    :endVal="senateMin"
                    text="Senate lowest number of sitting days"
                    />
                </v-flex>
                <v-flex xs12 md4 lg2>
                    <count-up
                    :endVal="senateAvg"
                    text="Senate average number of sitting days"
                    />
                </v-flex>
            </v-layout>

            <br/>

            <v-layout row wrap align-center justify-space-between>
                <v-btn-toggle v-model="chartType" class="transparent handbook_toggleButton" :mandatory="true">
                    <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="'perYear'">
                                <span class="long-button-text chamberButton">Number of sitting days per year</span>
                            </v-btn>
                        </template>
                        <span>Number of sitting days per year</span>
                    </v-tooltip>
                    <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="'heatmap'">
                                <span class="long-button-text chamberButton">Distribution of sitting days</span>
                            </v-btn>
                        </template>
                        <span>Distribution of sitting days</span>
                    </v-tooltip>
                </v-btn-toggle>
            </v-layout>

            <br/>

            <chart v-if="chartType === 'perYear'" :chartData="chartData"/>
            <heatmap v-if="chartType === 'heatmap'"></heatmap>

            <br/>

            <div class="stats-table">
                <v-data-table
                    :headers="headers" 
                    :items="items"
                    :pagination.sync="pagination"
                    :rows-per-page-items="ROWS_LISTITEMS" 
                    :hide-actions="true"
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                    :hide-headers="isMobile"
                    :loading="loading"
                    :disable-initial-sort="true">
                    <template v-slot:items="props">
                        <template v-if="isMobile">
                            <router-link class="tr" :to="{ name: 'SittingDayCalendar', params: { year: props.item.Year }}">
                                <td>
                                    <div class="flex-content">
                                        <div class="flex-item">
                                            <h3>{{ props.item.Name }}</h3>
                                        </div>
                                        <div class="flex-item">
                                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Year">
                                                {{ props.item.Year }}<v-chip v-if="props.item.Election" outline small label>Election</v-chip>
                                            </div>
                                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Reps sitting days">
                                                {{ props.item.RepsDays }}
                                            </div>
                                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Senate sitting days">
                                                {{ props.item.SenateDays }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </router-link>
                        </template>
                        <template v-if="!isMobile">
                            <router-link class="tr" :to="{ name: 'SittingDayCalendar', params: { year: props.item.Year }}">
                                <td class="text-xs-left"><strong>{{ props.item.Year }}</strong> <v-chip v-if="props.item.Election" outline small label>Election</v-chip></td>
                                <td class="text-xs-left">{{ props.item.RepsDays }}</td>
                                <td class="text-xs-left">{{ props.item.SenateDays }}</td>
                                <td class="text-xs-left">{{ props.item.EstimatesDays }}</td>
                            </router-link>
                        </template>
                    </template>
                    <template v-slot:footer>
                    </template>
                </v-data-table>
            </div>
            <br/>
            <v-layout row wrap>
                <v-flex xs12>

                    <v-btn class="csvButton" @click="exportDetailedCsv" v-on:keyup.enter="exportDetailedCsv" color="primary">
                        <v-icon aria-hidden="true" :class="detailedCsvDownloadClass">{{detailedCsvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download full list as CSV</span>
                    </v-btn>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>

                </v-flex>
            </v-layout>         

        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import Heatmap from './SittingCalendarHeatmap.vue';
import CountUp from "../StatisticalInformation/CountUp.vue";
import Chart from './Chart.vue';
import axios from 'axios';
import moment from 'moment'
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

function average (nums) {
    return nums.reduce((a, b) => (a + b)) / nums.length;
}

export default {
    created() {
        this.initialiseItems();
        this.initialiseMinistries();
    },
    components: {
        Loader,
        Chart,
        StatisticalHeader,
        CountUp,
        Heatmap
    },
    mounted() {
        this.onResize();
    },
    methods: {
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } 
            else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        initialiseItems() {
            this.loading = true;
            const url = `StatisticalInformation/SittingDaysPerYear`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                });
        },
        initialiseMinistries() {
            this.loadingMinistries = true;
            const url = `StatisticalInformation/Ministries`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.ministries = response.data;
                    this.loadingMinistries = false;
                });
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items.map(i => 
                ({ 
                    Year: i.Year,
                    'House of Representatives sitting days': i.RepsDays,
                    'Senate sitting days': i.SenateDays,
                    'Estimates days': i.EstimatesDays,
                    'Election': i.Election
                }));
            let headers = this.headers.map(h => h.text);
            const filename = 'Full list of sitting days';
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        },
        exportDetailedCsv: function () {
            this.detailedCsvDownloading = true;

            const url = `StatisticalInformation/SittingDaysForYear?year=`;
            axios.get(`api/${url}`)
                .then(response => {
                    const records = response.data.map(i => 
                        ({ 
                            Date: (new Date(i.Date)).toLocaleDateString(),
                            'House sitting': i.RepsSitting,
                            'Senate sitting': i.SenateSitting
                        }));
                    let headers = ['Date', 'House sitting', 'Senate sitting'];
                    const filename = 'Sitting days';
                    const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
                    this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.detailedCsvDownloading = false);
                });
        },
        stringDate (value) {
            if (value && value != 'undefined' && value != 'Undefined' 
            && value != '1900-01-01' 
            && value != '1900-01-01T00:00:00Z' 
            && value != '1900-01-1' 
            && value != '0001-01-01'
            && value != '0001-01-01T00:00:00Z') {
                var dateDMY = moment(String(value));
                if (dateDMY.isValid()){
                    return dateDMY.format('DD/MM/YYYY');
                }
                else {
                    var dateFormat =  moment(String(value), 'YYYY-DD-MM');
                    if (dateFormat.isValid()){
                        return dateFormat.format('DD/MM/YYYY');
                    }
                    else {
                        return ''
                    }
                }
            } else {
                return 'present'
            }
        }
    }, 
    computed: {
            csvDownloadIcon() {
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass() {
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            detailedCsvDownloadIcon() {
                return this.detailedCsvDownloading ? 'cached' : 'text_snippet';
            },
            detailedCsvDownloadClass() {
                let csvClass = 'mr-1';
                if (this.detailedCsvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            itemsReversed() {
                return [...this.items].reverse();
            },
            itemsExcludingLatest() {
                return this.items.slice(1);
            },
            houseMax() {
                return Math.max(...this.itemsExcludingLatest.map(i => i.RepsDays));
            },
            houseMin() {
                return Math.min(...this.itemsExcludingLatest.map(i => i.RepsDays));
            },
            houseAvg() {
                return average(this.itemsExcludingLatest.map(i => i.RepsDays));
            },
            senateMax() {
                return Math.max(...this.itemsExcludingLatest.map(i => i.SenateDays));
            },
            senateMin() {
                return Math.min(...this.itemsExcludingLatest.map(i => i.SenateDays));
            },
            senateAvg() {
                return average(this.itemsExcludingLatest.map(i => i.SenateDays));
            },
            chartData() {
                // need to be able to find prime ministers in a given year
                const getPrimeMinisterForYear = year => {
                    const ministries = this.ministries
                        .filter(m => moment(m.DateStart) < moment(new Date(year, 12, 31)) && (!m.DateEnd || moment(m.DateEnd) > moment(new Date(year, 1, 1))))
                        .map(m => ({ 
                            leaderPHID: m.LeaderPHID, 
                            ministryName: m.MinistryName,  
                            dateString: this.stringDate(m.DateStart) + '-' + this.stringDate(m.DateEnd)
                        }));
                    return ministries;
                }
                const plotLines = this.$store.getters.GET_PARLIAMENTS_ORDERED
                    .map(p => ({
                        value: (new Date(p.DateElection).getFullYear()).valueOf(),
                        dashStyle: 'shortdash',
                        color: '#CCD6EB',
                        label: {
                            text: p.PID,
                            y: 0
                        }}));

                return {
                chart: {
                    spacing: [10, 20, 15, 10]
                },
                title: {
                    text: 'Number of sitting days per year'
                },

                yAxis: {
                    title: {
                        text: 'Number of sitting days'
                    }
                },
                xAxis: [{
                    plotLines,

                },
                {
                    title: {
                        text: 'Parliaments'
                    },
                    offset: 15,
                    lineColor: 'transparent',
                    opposite: true
                }
                ],

                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: false
                        },
                        pointStart: 1901
                    }
                },
                tooltip: {
                    shared: true,
                    split: false,
                    followPointer: false,
                    borderWidth: 0,
                    backgroundColor: 'transparent',
                    shadow: false,
                    formatter: function () {
                        var points = this.points;
                        const pointsLength = points.length;
                        var leaders = getPrimeMinisterForYear(points[0].x);
                        var tooltipMarkup = `<b>${this.x}</b><br/>`;
                        for (let index = 0; index < pointsLength; index += 1) {
                            tooltipMarkup += '<span style="color:' + points[index].series.color + '">\u25CF</span> ' + points[index].series.name + ': <b>' 
                                + points[index].y
                                + '</b><br/>' ;
                        }

                        if (points.length) {
                            leaders.forEach(leader => {
                                tooltipMarkup += '<div><img style="display:inline-block; height: 50px; border-radius: 5px;" src="https://www.aph.gov.au/api/parliamentarian/' 
                                + leader.leaderPHID
                                + '/image" style="width: 80px;border-radius: 5px;"></img><div style="display:inline-block; padding-left:10px;">' 
                                + '<span style="font-size:1.1em;font-weight:bold;">' + leader.ministryName + '</span><br />' 
                                + '<span>' + leader.dateString + '</span>'
                                + '</div>';
                            })
                        }

                        return '<div class="tooltip">' + tooltipMarkup +'</div></div>';
                    },    
                    useHTML: true,
                },
                series: 
                [
                    {
                        name: 'House of Representatives sitting days',
                        data: this.itemsReversed.map(d => d.RepsDays),
                        color: this.$store.state.COLOUR_REPRESENTATIVES
                    },
                    {
                        name: 'Senate sitting days',
                        data: this.itemsReversed.map(d => d.SenateDays),
                        color: this.$store.state.COLOUR_SENATE
                    },
                    {
                        name: 'Estimates days',
                        data: this.itemsReversed.map(d => d.EstimatesDays || null),
                        color: this.$store.state.COLOUR_SENATE_BRIGHT
                    }
                ]
            }
        }
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
            isMobile: false,
            ROWS_LISTITEMS: [{
                "text": "$vuetify.dataIterator.rowsPerPageAll",
                "value": -1
            }],
            title: 'Sitting pattern',
            chartType: 'perYear',
            headers: [
                { text: 'Year', value: 'Year', width: '10%'},
                { text: 'House of Representatives sitting days', value: 'RepsDays', width: '20%'},
                { text: 'Senate sitting days', value: 'SenateDays', width: '20%'},
                { text: 'Estimates days', value: 'EstimatesDays', width: '20%'},
            ],
            items: [],
            ministries: [],
            search: '',
            loading: true,
            loadingMinistries: true,
            csvDownloading: false,
            detailedCsvDownloading: false,
            pagination: {
                rowsPerPage: -1,
                sortBy: 'Year',
                descending: true
            },
        }
    }
}
</script>
